// extracted by mini-css-extract-plugin
export default {"container":"modal_container__abcPR","link_container":"modal_link_container__o5Zqp","linked_wrap_title":"modal_linked_wrap_title__+0IYe","linked_wrap":"modal_linked_wrap__pSGQe"};